import { alpha, darken, lighten } from "@mui/material";
import {
  black,
  ChartColors,
  createBaseTheme,
  darkGray,
  gray,
  lightGray,
  orange,
  turquoise10,
  turquoise2,
  turquoise5,
  turquoise7,
  turquoise8,
  turquoise9,
  turquoiseAirmont,
  turquoiseShades,
  ultraLightGray,
  white,
} from "shared-ts-mui";
import { blue, red } from "@mui/material/colors";

const light_primary_main = "#669999";
const light_primary_container = "#f5fdfd";
const light_secondary_main = "#3D5252";
const light_secondary_container = "#eaeaea";
const light_background_table_header_text = "#555";

const defaultChartColors: ChartColors = {
  primary: turquoiseAirmont,
  primaryShades: turquoiseShades,
  secondary: turquoise8,
  tertiary: orange,
  warning: alpha(red[500], 0.9),
  threshold: alpha(blue[500], 1),
};

const default_background = "#eaeaea";
const default_background_paper_light = "#ffffff";

export const lightThemeOptions = createBaseTheme({
  cssVariables: true,
  palette: {
    mode: "light",

    primary: {
      main: light_primary_main,
      light: light_primary_container
    },
    secondary: {
      main: light_secondary_main,
      light: light_secondary_container,
      dark: light_secondary_main,
    },
    tertiary: {
      main: orange,
    },
    background: {
      default: default_background,
      paper: default_background_paper_light,
      card: default_background_paper_light,
    },
    input: {
      background: darken(default_background_paper_light, 0.05),
      hover: darken(default_background, 0.08),
    },
    action: {
      hover: turquoise8,
      //hoverOpacity: 0.8,
    },
    actionGroup: {
      //standard farge
      primary: lightGray,
      primaryText: black,
      selected: turquoise7, //darken(airmontTurquoise, 0.3),
      selectedText: turquoise2,
      hover: turquoise8,
    },
    chart: defaultChartColors,
    grid: {
      main: white,
      columnHeader: {
        background: turquoise10,
      },
      rowHeader: {
        color: light_background_table_header_text,
        background: turquoise10,
        fontWeight: 800,
        fontSize: "10px",
      },
      dataRow: {
        selected: turquoise9,
        hover: ultraLightGray,
      },
    },
  },
});

const dark_primary_main = "#9ACCCC";
const dark_primary_container = "#3D5252";
const dark_secondary_main = "#669999";
const dark_text_primary = "#ebebeb";
const dark_background_default = "#181818";
const dark_background_paper = "#222222";
const dark_background_table_header_text = "#999";

export const darkThemeOptions = createBaseTheme({
  cssVariables: true,
  palette: {
    mode: "dark",
    primary: {
      dark: dark_primary_container,
      light: dark_background_default,
      main: dark_primary_main,
    },
    secondary: {
      main: dark_secondary_main,
      light: dark_background_default,
    },
    text: {
      primary: dark_text_primary,
    },
    background: {
      default: dark_background_default,
      paper: dark_background_paper,
      card: dark_background_paper,
    },
    input: {
      background: lighten(dark_background_paper, 0.05),
      hover: darken(dark_background_paper, 0.04),
    },
    action: {
      selected: turquoise5,
      //selectedText: white,
      hover: turquoiseAirmont,
      hoverOpacity: 0.5,
    },
    actionGroup: {
      primary: darkGray,
      primaryText: white,
      selected: turquoise2,
      selectedText: white,
      hover: turquoiseAirmont,
      hoverText: white,
    },
    chart: { ...defaultChartColors, secondary: gray },
    grid: {
      main: lighten(dark_background_paper, 0.05),
      columnHeader: {
        background: darken(dark_background_paper, 0.04),
      },
      rowHeader: {
        color: dark_background_table_header_text,
        background: darken(dark_background_paper, 0.04),
        selected: darken(dark_background_paper, 0.15),
        fontWeight: 800,
        fontSize: "10px",
      },
      dataRow: {
        background: lighten(dark_background_paper, 0.05),
        selected: darken(dark_background_paper, 0.15),
        hover: lighten(dark_background_paper, 0.15),
      },
    },
  },
});
